import formatToCurrencyBrl from './formatToCurrencyBrl'

const numberToPrice = (number, discountPercentage, splitsNumber = 1) => {
  if (splitsNumber > 1) {
    var splitedPrice = number / splitsNumber

    if (discountPercentage) {
      var finalPrice =
        parseFloat(splitedPrice) -
        parseFloat(splitedPrice) * (parseInt(discountPercentage) / 100)

      return `De ${splitsNumber}x de R$ ${formatToCurrencyBrl(
        splitedPrice,
      )} por ${splitsNumber}x de R$ ${formatToCurrencyBrl(finalPrice)}`
    }

    return `${splitsNumber}x de R$ ${formatToCurrencyBrl(splitedPrice)}`
  }

  if (discountPercentage) {
    var recurringPrice =
      parseFloat(number) -
      parseFloat(number) * (parseInt(discountPercentage) / 100)

    return `De R$ ${formatToCurrencyBrl(number)} por R$ ${formatToCurrencyBrl(
      recurringPrice,
    )}`
  }

  return `R$ ${formatToCurrencyBrl(number)}`
}

export default numberToPrice
